import React, { useState } from "react";
import ButtonEdit from "../../components/Button/ButtonEdit";
import ButtonDelete from "../../components/Button/ButtonDelete";
import { FaExternalLinkAlt, FaFilePdf } from "react-icons/fa";

const ReglementCard = ({ reglement, onEdit, onDelete, canModify }) => {
  const [expanded, setExpanded] = useState(false);

  const hasImage = !!reglement.lien_url_image;
  const hasLink = !!reglement.lien_url;
  const contentHtml = reglement.content || "";

  const toggleExpanded = (e) => {
    if (e) {
      e.stopPropagation();
      e.preventDefault();
    }
    setExpanded((v) => !v);
  };

  const handleOpenDocument = (e) => {
    // Empêche toute propagation à des parents cliquables
    e.stopPropagation();
    e.preventDefault();

    if (reglement.lien_url) {
      window.open(reglement.lien_url, "_blank", "noopener,noreferrer");
    }
  };

  return (
    <article className="group relative flex flex-col rounded-2xl border border-slate-200/80 dark:border-slate-700/80 bg-white/95 dark:bg-slate-900/80 shadow-sm hover:shadow-md transition overflow-hidden">
      {/* Bandeau haut */}
      <div className="px-4 py-3 border-b border-slate-200/70 dark:border-slate-700/70 bg-gradient-to-r from-slate-900 via-slate-800 to-slate-900 text-white">
        <h3 className="text-sm sm:text-base font-semibold leading-snug font-montserrat line-clamp-2">
          {reglement.title}
        </h3>
      </div>

      {/* Image éventuelle */}
      {hasImage && (
        <div className="relative">
          <img
            src={reglement.lien_url_image}
            alt={reglement.title}
            className="w-full h-40 object-cover sm:h-44"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/30 via-transparent to-transparent pointer-events-none" />
        </div>
      )}

      {/* Corps */}
      <div className="flex-1 px-4 py-3 flex flex-col gap-3">
        {/* Contenu texte */}
        {contentHtml && (
          <div className="text-xs sm:text-sm text-slate-700 dark:text-slate-200">
            <div
              className={
                expanded
                  ? "max-h-52 overflow-y-auto pr-1 custom-scrollbar"
                  : "max-h-20 overflow-hidden"
              }
            >
              <div dangerouslySetInnerHTML={{ __html: contentHtml }} />
            </div>

            <button
              type="button"
              onClick={toggleExpanded}
              className="mt-1 text-[0.7rem] inline-flex items-center text-primary hover:text-primary/80 underline underline-offset-2"
            >
              {expanded ? "Afficher moins" : "Afficher plus"}
            </button>
          </div>
        )}

        {/* Bouton document si présent */}
        {hasLink && (
          <button
            type="button"
            onClick={handleOpenDocument}
            className="inline-flex items-center gap-2 text-xs sm:text-sm font-semibold text-primary hover:text-primary/80 mt-1"
          >
            <span className="inline-flex h-7 w-7 items-center justify-center rounded-full bg-primary/10 text-primary">
              <FaFilePdf className="text-[0.9rem]" />
            </span>
            <span>Voir le règlement (document)</span>
            <FaExternalLinkAlt className="text-[0.65rem] opacity-70" />
          </button>
        )}
      </div>

      {/* Footer actions admin */}
      {canModify && (
        <div className="px-4 py-2 border-t border-slate-200/70 dark:border-slate-700/70 flex justify-end gap-2 bg-slate-50/80 dark:bg-slate-900/80">
          <ButtonEdit
            onClick={(e) => {
              e.stopPropagation();
              e.preventDefault();
              onEdit();
            }}
          />
          <ButtonDelete
            onClick={(e) => {
              e.stopPropagation();
              e.preventDefault();
              onDelete();
            }}
          />
        </div>
      )}
    </article>
  );
};

export default ReglementCard;
